
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.188 14.234c.99.521 1.927.782 2.812.782.885 0 1.81-.26 2.773-.782.99-.52 1.732-1.159 2.227-1.914-.026-.729-.612-1.34-1.758-1.836-1.146-.494-2.226-.742-3.242-.742s-2.096.248-3.242.742c-1.146.47-1.732 1.081-1.758 1.836.495.755 1.224 1.393 2.188 1.914zm4.57-10.312C10.263 3.427 9.678 3.18 9 3.18c-.677 0-1.263.247-1.758.742-.495.495-.742 1.08-.742 1.758 0 .677.247 1.263.742 1.758.495.494 1.08.742 1.758.742.677 0 1.263-.248 1.758-.742.495-.495.742-1.081.742-1.758s-.247-1.263-.742-1.758zM3.102 3.14C4.742 1.5 6.708.68 9 .68s4.245.82 5.86 2.46C16.5 4.756 17.32 6.709 17.32 9c0 2.292-.82 4.258-2.46 5.898-1.615 1.615-3.568 2.422-5.86 2.422-2.292 0-4.258-.807-5.898-2.422C1.487 13.258.68 11.292.68 9s.807-4.245 2.422-5.86z","fill":"currentColor"}})])
          )
        }
      }
    